// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-dropdown-menu{
    min-width: 150px!important;
}



#mobile-margins > div{
    font-weight: 400;
    font-size: 1.2rem;
    font-family: "Roboto","sans-serif";
    color: #333;
    padding: 3px 18px 5px;
    line-height: 1.4285;
    min-width:150px;
}

.themeTextRows #mobile-margins > div{
    float: left;
}

.prop-detail #mobile-margins > div{
    padding: 0;
    padding-right: 3px;
    min-width:50px;
}

.margin-optionButton{
    height: 30px;
    border: 1px solid #a8a8a8;
    width: 20px;
    padding: 1px;
    margin-left: 5px;
    border-radius: 3px;
}

.prop-detail .margin-optionButton{
    height: 25px;
    margin-left: 0;
}

.margin-optionButton:hover{
    box-shadow: 0 1px 2px rgba(0,0,0,.5);
    border: 2px solid  var(--main-primary);
}

#mobile-margins .selected, .margin-optionButton.selected{
    box-shadow: 0 1px 2px rgba(0,0,0,.5);
    border: 2px solid  var(--main-primary);
}

.margin-optionButton:active{
    border: 2px solid  var(--main-primary);
}

.margin-optionButton-margin{
    fill: #cc7929;
    stroke-width: 0.26463637;
}

.margin-optionButton-path{
    fill: #a8a8a8;
    stroke-width: 0.26457524;
}

.mobile-page{
    margin-left: auto;
    margin-right: auto; 
    display: block;
    box-shadow: none; 
    border: 1px solid #d5d5d5;
    background-color: #e2e3e6!important;
}

#mobile-columns-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
}

#mobile-columns-wrapper {
    display: inline-flex;
}


.mobile-column{
    background-color: #fff;
    min-height: 345px;
    min-width: 350px;
    max-width: 375px;
    display: block;
    margin: 3px;
    border: 1px #ccc solid;
    border-radius: 3px;
}

.mobile-column-title{
    padding: 10px;
    font-size: 1.3rem;
    color: #333;
    font-weight: 700;
    float: left;
}

div.mobile-column-counter {
    float: right;
    min-width: 20px;
    height: 20px;
    margin-top: 10px;
    border-radius: 15px;
    text-align: center;
    color: #FFFFFF;
    background-color:  var(--main-primary);
    font-size: 1.3rem;
    padding-top: 2px;
    margin-right: 10px;
}

#reset-columns {
    color: #000000;
}

div.mobile-group-handler {
    float: left;
    position: relative;
    margin-top : 4px;
}

div.mobile-group-handler-disabled {
    color: #CCCCCC;
}

div.mobile-group-handler-enabled {
    color: #000000;
}

div.mobile-group-handler-selected {
    color:  var(--main-primary);
}

div.mobile-control-placeholder {
    min-height: 22px;
    width: 100%;
    border: 1px dashed #000;
}

.mobile-dragging-move-cursor {
    cursor: move;
}

.mobile-dragging-default-cursor {
    cursor: default;
}

.mobile-section-placeholder-container{
    height: auto;
    display: inline-block;
    width: 100%;
}

.section-placeholder-text-container{
    background-color: #F3F3F3;
    border-radius: 3px;
    border: 1px solid var(--mobile-buttons);
    margin: 5px;
    min-height: 345px;
    text-align: center;
    opacity: 0.4;
}

.section-placeholder-text{
    color: var(--mobile-buttons);
    min-height: 320px;
    font-size: 16px;
    font-weight: 800;
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sales-link{
    color: #F89B3C!important;
    font-weight: bold!important;
}`, "",{"version":3,"sources":["webpack://./assets/style/mobile/mobile-designer.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B;;;;AAIA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B","sourcesContent":[".mobile-dropdown-menu{\r\n    min-width: 150px!important;\r\n}\r\n\r\n\r\n\r\n#mobile-margins > div{\r\n    font-weight: 400;\r\n    font-size: 1.2rem;\r\n    font-family: \"Roboto\",\"sans-serif\";\r\n    color: #333;\r\n    padding: 3px 18px 5px;\r\n    line-height: 1.4285;\r\n    min-width:150px;\r\n}\r\n\r\n.themeTextRows #mobile-margins > div{\r\n    float: left;\r\n}\r\n\r\n.prop-detail #mobile-margins > div{\r\n    padding: 0;\r\n    padding-right: 3px;\r\n    min-width:50px;\r\n}\r\n\r\n.margin-optionButton{\r\n    height: 30px;\r\n    border: 1px solid #a8a8a8;\r\n    width: 20px;\r\n    padding: 1px;\r\n    margin-left: 5px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.prop-detail .margin-optionButton{\r\n    height: 25px;\r\n    margin-left: 0;\r\n}\r\n\r\n.margin-optionButton:hover{\r\n    box-shadow: 0 1px 2px rgba(0,0,0,.5);\r\n    border: 2px solid  var(--main-primary);\r\n}\r\n\r\n#mobile-margins .selected, .margin-optionButton.selected{\r\n    box-shadow: 0 1px 2px rgba(0,0,0,.5);\r\n    border: 2px solid  var(--main-primary);\r\n}\r\n\r\n.margin-optionButton:active{\r\n    border: 2px solid  var(--main-primary);\r\n}\r\n\r\n.margin-optionButton-margin{\r\n    fill: #cc7929;\r\n    stroke-width: 0.26463637;\r\n}\r\n\r\n.margin-optionButton-path{\r\n    fill: #a8a8a8;\r\n    stroke-width: 0.26457524;\r\n}\r\n\r\n.mobile-page{\r\n    margin-left: auto;\r\n    margin-right: auto; \r\n    display: block;\r\n    box-shadow: none; \r\n    border: 1px solid #d5d5d5;\r\n    background-color: #e2e3e6!important;\r\n}\r\n\r\n#mobile-columns-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n}\r\n\r\n#mobile-columns-wrapper {\r\n    display: inline-flex;\r\n}\r\n\r\n\r\n.mobile-column{\r\n    background-color: #fff;\r\n    min-height: 345px;\r\n    min-width: 350px;\r\n    max-width: 375px;\r\n    display: block;\r\n    margin: 3px;\r\n    border: 1px #ccc solid;\r\n    border-radius: 3px;\r\n}\r\n\r\n.mobile-column-title{\r\n    padding: 10px;\r\n    font-size: 1.3rem;\r\n    color: #333;\r\n    font-weight: 700;\r\n    float: left;\r\n}\r\n\r\ndiv.mobile-column-counter {\r\n    float: right;\r\n    min-width: 20px;\r\n    height: 20px;\r\n    margin-top: 10px;\r\n    border-radius: 15px;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    background-color:  var(--main-primary);\r\n    font-size: 1.3rem;\r\n    padding-top: 2px;\r\n    margin-right: 10px;\r\n}\r\n\r\n#reset-columns {\r\n    color: #000000;\r\n}\r\n\r\ndiv.mobile-group-handler {\r\n    float: left;\r\n    position: relative;\r\n    margin-top : 4px;\r\n}\r\n\r\ndiv.mobile-group-handler-disabled {\r\n    color: #CCCCCC;\r\n}\r\n\r\ndiv.mobile-group-handler-enabled {\r\n    color: #000000;\r\n}\r\n\r\ndiv.mobile-group-handler-selected {\r\n    color:  var(--main-primary);\r\n}\r\n\r\ndiv.mobile-control-placeholder {\r\n    min-height: 22px;\r\n    width: 100%;\r\n    border: 1px dashed #000;\r\n}\r\n\r\n.mobile-dragging-move-cursor {\r\n    cursor: move;\r\n}\r\n\r\n.mobile-dragging-default-cursor {\r\n    cursor: default;\r\n}\r\n\r\n.mobile-section-placeholder-container{\r\n    height: auto;\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n.section-placeholder-text-container{\r\n    background-color: #F3F3F3;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--mobile-buttons);\r\n    margin: 5px;\r\n    min-height: 345px;\r\n    text-align: center;\r\n    opacity: 0.4;\r\n}\r\n\r\n.section-placeholder-text{\r\n    color: var(--mobile-buttons);\r\n    min-height: 320px;\r\n    font-size: 16px;\r\n    font-weight: 800;\r\n    width: 75%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.sales-link{\r\n    color: #F89B3C!important;\r\n    font-weight: bold!important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
